var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9, _path10, _path11, _path12, _g4, _g5, _g6, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g7, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g8, _g9, _g10, _g11, _path31, _path32, _path33, _g12, _g13, _g14, _g15, _path34, _path35, _path36, _path37, _g16, _g17, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g18, _g19, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g20, _g21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHousePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.77 215.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.15,92.97l141.53-23.87,2.85-4.31-142.59,24.1",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.9,139.55l27.59,8.88,3-1,21.63,6.55v2.35l16.14,5.16.47-70.59,1.46,1.68,1.9-4L195.75,9.97l-68.97,48.62,2.21,4.2,5.62-1.05-1.23,3.52,59.93,13.84",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.41,161.68l-16.44-5.25v-2.35l-21.48-6.5-3.01,1h-.04s-27.59-8.89-27.59-8.89l.09-.28,27.55,8.86,3-1h.05s21.73,6.59,21.73,6.59v2.35l15.85,5.06.47-70.79,1.57,1.81,1.76-3.71L195.73,10.16l-68.76,48.47,2.09,3.99,5.76-1.08-1.26,3.6,59.77,13.81-.06.29-60.1-13.88,1.21-3.43-5.47,1.03-2.32-4.41.11-.08L195.77,9.77l.09.1,69.41,78.67-2.04,4.3-1.35-1.56-.46,70.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,97.53v78.81l18.5-4.42v-4.15l83.43-18.7,4,1.99,14.17-3.12v-68.37",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.65,176.52v-78.99h.3v78.62l18.2-4.35v-4.16l.12-.03,83.48-18.71,4.01,1.99,14-3.08v-68.25h.3v68.49l-.12.03-14.21,3.13-4-1.99-83.26,18.66v4.15l-18.8,4.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.71,74.47l-.09,65.57,72.18,36.3v-78.81",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.95,176.58l-.22-.11L.47,140.13v-.09l.09-65.57h.3l-.09,65.47,71.89,36.15v-78.56h.3v79.05Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.82,106.65l-.53,25.8,18.12-3.94v-25.65l-17.59,3.78Z",
    fill: "#224d6f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.65,103.27v25.48l3.37,1.62v-28.07l-3.37.97Z",
    fill: "#224d6f"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.26,100.84l138.98-24.81v-6.59l-137.1,23.53-1.73-1.3-.15,9.17Z",
    fill: "#224d6f"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.51,85.18c-.16,0-.33-.07-.45-.2L218.24,9.21c-.23-.25-.22-.64.04-.87.25-.23.64-.22.87.04l69.81,75.77c.23.25.22.64-.03.87-.12.11-.27.16-.42.16h0Z",
    fill: "#224d6f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M313.62,81c-.16,0-.32-.06-.45-.19L243.29,7.49c-.24-.25-.22-.64.02-.87.25-.24.64-.22.87.02l69.88,73.31c.24.25.22.64-.02.87-.12.12-.27.17-.42.17Z",
    fill: "#224d6f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.73,76.82c-.16,0-.32-.06-.44-.18L268.35,5.77c-.24-.24-.24-.63,0-.87.24-.24.63-.24.87,0l69.94,70.86c.24.24.24.63,0,.87-.12.12-.28.18-.43.18h0Z",
    fill: "#224d6f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M363.84,72.63c-.16,0-.31-.06-.43-.17L293.4,4.05c-.25-.24-.25-.63,0-.87.24-.25.63-.25.87,0l70.01,68.41c.25.24.25.63,0,.87-.12.12-.28.19-.44.19h0Z",
    fill: "#224d6f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M388.95,68.45c-.15,0-.3-.06-.42-.17L318.46,2.32c-.25-.23-.26-.62-.03-.87s.62-.26.87-.03l70.07,65.96c.25.23.26.62.03.87-.12.13-.29.2-.45.2Z",
    fill: "#224d6f"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.77,127l-145.77,38.81-9.27,1.79-56.33-18.29-118.32,30.51-15.28-3.48,18.5-4.42.34-4.15,83.09-18.7,3.74,2.04,14.43-3.44v-8.11l13.01,4.23,14.58,4.66,3-1.02,21.63,6.55v2.35l16.14,5.16,138.98-35.97v-4.64l17.52,6.13Z",
    fill: "#224d6f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.25,10.33l69.84,78.24,142.44-23.77L335.98.62l-139.24,9.71",
    fill: "#0e90d0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.75,92.86l137.52-23.53v56.07l-138.98,35.97v-69.95",
    fill: "#0e90d0"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.24,156.41c-.34,0-.62-.27-.62-.62v-66.33c0-.34.27-.62.62-.62s.62.27.62.62v66.33c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.51,151.16c-.34,0-.62-.27-.62-.62v-64.55c0-.34.27-.62.62-.62s.62.27.62.62v64.55c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M323.78,145.91c-.34,0-.62-.27-.62-.62v-62.77c0-.34.27-.62.62-.62s.62.27.62.62v62.77c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344.05,140.67c-.34,0-.62-.27-.62-.62v-60.99c0-.34.27-.62.62-.62s.62.27.62.62v60.99c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M364.32,135.42c-.34,0-.62-.27-.62-.62v-59.22c0-.34.27-.62.62-.62s.62.27.62.62v59.22c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M384.59,130.18c-.34,0-.62-.27-.62-.62v-57.44c0-.34.27-.62.62-.62s.62.27.62.62v57.44c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.73,93.59c-.2,0-.39-.1-.51-.27-.13-.2-.14-.46-.02-.66l2.67-4.48c.09-.16.25-.26.43-.29l142.13-23.69c.25-.04.5.08.63.3.13.22.11.5-.05.7l-2.96,3.7c-.09.12-.23.2-.38.22l-141.84,24.48s-.07,0-.11,0h0ZM265.78,89.05l-1.84,3.09,140.3-24.21,1.8-2.26-140.26,23.38h0Z",
    fill: "#224d6f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,74.47l71.5,23.06,118.55-18.33-77.85-18.56L1.3,74.47Z",
    fill: "#0e90d0"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,104.32c-.06,0-.13-.01-.2-.03L.68,80.24c-.32-.11-.5-.46-.39-.78.11-.32.46-.5.78-.39l71.78,24,119.95-18.36c.33-.05.65.18.7.52.05.34-.18.65-.52.7l-120.1,18.38s-.06,0-.09,0h0Z",
    fill: "#224d6f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,176.96c-.09,0-.19-.02-.28-.06L.34,140.59c-.21-.11-.34-.32-.34-.55l.09-65.57c0-.2.09-.38.25-.5.16-.12.36-.15.55-.09l72.1,23.06c.26.08.43.32.43.59v78.81c0,.21-.11.41-.29.53-.1.06-.21.09-.32.09h0ZM1.23,139.66l70.95,35.68v-77.36L1.32,75.32l-.09,64.34h0Z",
    fill: "#224d6f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,98.15c-.06,0-.13,0-.19-.03L.52,75.06c-.27-.09-.45-.36-.43-.64.03-.29.25-.52.54-.56l113.39-13.82c.07,0,.15,0,.22.01l78.81,18.91c.29.07.48.33.47.63-.01.3-.23.54-.53.58l-120.1,17.97s-.06,0-.09,0h0ZM3.58,74.74l69.27,22.16,116.82-17.48-75.61-18.15L3.58,74.74Z",
    fill: "#224d6f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,176.96c-.14,0-.27-.05-.38-.13-.15-.12-.23-.3-.23-.48v-78.81c0-.3.22-.56.53-.61l120.1-17.97c.18-.03.36.03.49.14.14.12.22.29.22.47v68.1c0,.29-.19.53-.47.6l-14.43,3.44c-.33.08-.66-.12-.74-.45-.08-.33.12-.66.46-.74l13.95-3.33v-66.89l-118.87,17.78v77.49l17.74-4.24c.33-.08.66.12.74.45.08.33-.12.66-.45.74l-18.5,4.42s-.09.02-.14.02h0Z",
    fill: "#224d6f"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M261.26,162.1c-.13,0-.27-.04-.38-.13-.15-.12-.24-.3-.24-.49v-70.19c0-.26.16-.49.4-.58.24-.09.52-.02.68.17l1.23,1.42,137.18-23.48c.18-.03.36.02.5.14.14.12.22.29.22.47v56.07c0,.28-.19.53-.46.6l-138.98,35.97s-.1.02-.15.02h0ZM261.88,92.94v67.74l137.75-35.65v-54.86l-136.8,23.41c-.22.04-.43-.04-.57-.2l-.38-.43h0Z",
    fill: "#224d6f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M265.39,89.11c-.17,0-.34-.07-.46-.2L194.79,10.74c-.16-.17-.2-.43-.11-.64.09-.22.3-.37.53-.38L335.94,0c.16,0,.33.04.46.16l71.54,64.18c.18.16.25.4.18.63-.06.23-.26.4-.49.44l-142.13,23.69s-.07,0-.1,0h0ZM196.55,10.86l69.08,76.97,140.53-23.43L335.76,1.25l-139.21,9.6Z",
    fill: "#224d6f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.26,162.1c-.06,0-.13,0-.19-.03l-16.14-5.16c-.32-.1-.5-.45-.4-.77.1-.33.45-.51.77-.4l15.34,4.9v-69.35c0-.34.27-.62.62-.62s.62.27.62.62v70.19c0,.2-.09.38-.25.5-.11.08-.23.12-.36.12h0Z",
    fill: "#224d6f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.49,149.06c-.06,0-.12,0-.19-.03l-19.75-6.31-7.85-2.58c-.32-.11-.5-.45-.39-.78.11-.33.45-.5.78-.39l7.84,2.58,19.74,6.31c.32.1.5.45.4.77-.08.26-.32.43-.59.43h0Z",
    fill: "#224d6f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M262.73,93.59c-.17,0-.34-.07-.46-.21L194.59,16.67l-65.33,46c-.14.1-.32.14-.49.1-.17-.04-.32-.14-.4-.3l-1.78-3.09c-.16-.27-.08-.62.17-.81L194.89,9.82c.28-.2.66-.14.86.14.2.28.14.66-.14.86l-67.66,48.44,1.16,2.02L194.33,15.34c.26-.18.61-.14.82.1l68.03,77.12c.22.25.2.64-.05.87-.12.1-.26.15-.41.15h0Z",
    fill: "#224d6f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.98,65.87c-.34,0-.62-.27-.62-.62v-3.52c0-.34.27-.62.62-.62s.62.27.62.62v3.52c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91,62.79c-.31,0-.58-.23-.61-.55-.04-.34.2-.64.54-.68l4.92-.57,62.84-43.1c.28-.19.66-.12.86.16.19.28.12.66-.16.86l-62.96,43.19c-.08.06-.18.09-.28.1l-5.07.58s-.05,0-.07,0h0Z",
    fill: "#224d6f"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.19,61.28l64.5-45.23,66.72,75.62-.26,2.46L196.79,24.92l-55.8,38.82-6.76-1.56-4.04-.9Z",
    fill: "#224d6f"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.69,146.91l-3.74-23.67c-4.42-16.38-9.64-29.11-19.05-43.68v59.99",
    fill: "#224d6f"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.73,149.06v-49.49l-83.43,14.58v53.61",
    fill: "#224d6f"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.05,120.69c-.3,0-.56-.21-.61-.51-.06-.34.17-.66.5-.71l75.41-13.21c.34-.06.66.17.71.5.06.34-.17.66-.5.71l-75.41,13.21s-.07,0-.11,0h0Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,128.73c-.29,0-.55-.21-.61-.51-.06-.33.16-.66.49-.72l75.48-14.01c.34-.06.66.16.72.49.06.33-.16.66-.49.72l-75.48,14.01s-.08.01-.11.01Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,136.77c-.29,0-.55-.2-.61-.5-.06-.33.15-.66.49-.72l75.56-14.8c.34-.06.66.15.72.49.06.33-.15.66-.49.72l-75.56,14.8s-.08.01-.12.01Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,144.8c-.29,0-.54-.2-.6-.49-.07-.33.14-.66.48-.73l75.63-15.59c.33-.07.66.15.73.48.07.33-.14.66-.48.73l-75.63,15.59s-.08.01-.12.01h0Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,152.84c-.28,0-.54-.2-.6-.49-.07-.33.14-.66.47-.73l75.7-16.38c.33-.07.66.14.73.47.07.33-.14.66-.47.73l-75.7,16.38s-.09.01-.13.01Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,160.88c-.28,0-.53-.19-.6-.48-.07-.33.13-.66.47-.74l75.77-17.17c.33-.07.66.13.74.47.07.33-.13.66-.47.74l-75.77,17.17s-.09.01-.14.01h0Z",
    fill: "#224d6f"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3,168.46c-.28,0-.54-.19-.6-.48-.07-.33.13-.66.47-.74l82.95-18.67v-48.68c0-.34.27-.62.62-.62s.62.27.62.62v49.17c0,.29-.2.54-.48.6l-83.43,18.78s-.09.01-.14.01Z",
    fill: "#224d6f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37,147.91c-.34,0-.62-.27-.62-.62v-54.32c0-.34.27-.62.62-.62s.62.27.62.62v54.32c0,.34-.27.62-.62.62Z",
    fill: "#224d6f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M245.13,154.59c-.06,0-.12,0-.18-.03l-21.44-6.49-2.82.96c-.32.11-.67-.06-.78-.39-.11-.32.06-.67.39-.78l3-1.02c.12-.04.25-.04.38,0l21.63,6.55c.32.1.51.44.41.77-.08.27-.32.44-.59.44h0Z",
    fill: "#224d6f"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.42,93.49v54.56l-2.93-.63-3,1.02v-56.11l5.93,1.16Z",
    fill: "#224d6f"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.86,92.8l.63,54.63c.79,1.71,21.63,6.55,21.63,6.55v-56.84l-20.05-3.6",
    fill: "#224d6f"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.71,74.47c0,.33.17,5.18.17,5.18l71.92,24.04,120.1-18.38v-5.75l-120.1,17.97L.71,74.47Z",
    fill: "#224d6f"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.15,112.96v52.78l-6.85,1.44v-53.03l6.85-1.2Z",
    fill: "#224d6f"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.48,183.33l16.91,10.79,10.34-2.85-27.25-7.94Z",
    fill: "#224d6f"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M223.01,209.38l-19.36-11.87-10.4,2.97,29.76,8.9Z",
    fill: "#224d6f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M157.35,205.24l30.57-5.09-9.76-4.21-20.81,9.29Z",
    fill: "#224d6f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M222.47,186.95l-28.57,4.63,9.82,4.08,18.76-8.71Z",
    fill: "#224d6f"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.71,210.95l5.18-7.63-9.05-.56,3.87,8.19Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.08,182.05l-4.88,6.59,8.63.52-3.76-7.11Z",
    fill: "#224d6f"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.4,198.34l-21.19-2.85-.04,3.12,21.24-.27Z",
    fill: "#224d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.03,193.3l20.57,2.82.46-3.07-21.03.25Z",
    fill: "#224d6f"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.08,194.64c2.17.91,2.09,2.18-.19,2.83-2.3.65-5.94.43-8.1-.5-2.15-.92-2.02-2.18.27-2.82,2.28-.64,5.87-.42,8.03.49h0Z",
    fill: "#224d6f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.81,177.42l8.45,3.55-2.2.57-7.98-.98h-.06s4.45,1.91,4.45,1.91l-2.67.69-8.41-3.6,2.26-.57,7.85.98.08-.02-4.39-1.85,2.63-.66h0Z",
    fill: "#224d6f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M230.04,211.2c-.36-.13-.74-.21-1.15-.22-.41-.01-.83.05-1.27.18-.28.09-.48.17-.59.25s-.15.16-.12.24c.03.08.12.15.27.21.12.06.25.09.4.12.15.03.32.04.51.04s.4-.01.64-.04c.24-.03.5-.06.79-.12l1-.18c.67-.12,1.31-.2,1.9-.24s1.14-.04,1.67,0c.52.04,1,.11,1.46.21.46.1.88.24,1.28.4.68.29,1.1.58,1.26.89.15.3.05.6-.3.9-.35.3-.95.58-1.8.84-.87.27-1.77.46-2.69.54-.92.09-1.85.07-2.77-.06-.92-.13-1.82-.38-2.7-.75l2.6-.81c.34.13.68.22,1.04.27.35.05.72.06,1.08.03.36-.03.72-.1,1.06-.21.29-.09.5-.18.62-.27.12-.09.17-.18.13-.27-.03-.09-.13-.17-.3-.24-.16-.06-.35-.11-.57-.13-.22-.02-.48-.02-.8,0s-.7.08-1.16.16l-1.22.22c-1.09.19-2.13.27-3.11.23-.98-.04-1.88-.23-2.68-.58-.66-.28-1.06-.58-1.2-.89-.14-.32-.04-.62.3-.93.34-.3.91-.58,1.7-.82.81-.25,1.64-.4,2.51-.46.87-.06,1.71-.04,2.53.08s1.57.31,2.25.59l-2.59.8h0Z",
    fill: "#224d6f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M230.41,187.9l-9.46-3.7,6.61-1.83,2.05.79-4.11,1.15,1.62.63,3.77-1.06,2.07.8-3.78,1.06,1.63.64,4.1-1.16,2.09.81-6.6,1.88h0Z",
    fill: "#224d6f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.98,211.31l-12.35-3.43,3.29-.91,7.08,2.23.09-.02-3.86-3.12,2.56-.71,7.37,2.14.08-.02-4.19-3.02,3.21-.89,6.07,5.12-2.78.79-6.98-1.89-.08.02,3.32,2.93-2.82.8h0Z",
    fill: "#224d6f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09,93.62c-.06,0-.13,0-.19-.03l-69.38-22.55c-.32-.11-.5-.45-.4-.78.11-.32.45-.5.78-.4l69.38,22.55c.32.11.5.45.4.78-.09.26-.33.43-.59.43h0Z",
    fill: "#224d6f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.96,89.49c-.06,0-.13-.01-.2-.03l-63.62-21.65c-.32-.11-.49-.46-.38-.78.11-.32.46-.5.78-.38l63.62,21.66c.32.11.49.46.38.78-.09.26-.33.42-.58.42h0Z",
    fill: "#224d6f"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.06,84.73c-.06,0-.12,0-.17-.02l-70.41-20.64c-.33-.1-.51-.44-.42-.77.1-.33.44-.51.77-.42l70.41,20.64c.33.1.51.44.42.77-.08.27-.32.44-.59.44Z",
    fill: "#224d6f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M245.13,156.93c-.34,0-.62-.27-.62-.62v-58.68l-23.4-4.55v54.73c0,.34-.27.62-.62.62s-.62-.27-.62-.62v-55.48c0-.18.08-.36.22-.48.14-.12.33-.17.51-.13l24.63,4.79c.29.06.5.31.5.61v59.19c0,.34-.27.62-.62.62h0Z",
    fill: "#224d6f"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.62,140.04v-9.09l72.18,34.99,18.65-4.33-.15,10.31-18.5,4.42L.62,140.04Z",
    fill: "#224d6f"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.73,139.48l3.74,1.05,14.43-2.76v10.16l-14.17,3.12-4-2.34v-9.23Z",
    fill: "#224d6f"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3,172.54c-.34,0-.62-.27-.62-.62v-57.77c0-.3.22-.56.51-.61l87.17-15.23c.18-.03.36.02.5.14.14.12.22.29.22.47v52.18c0,.22-.12.42-.3.53-.19.11-.42.12-.61.01l-3.74-2.04c-.3-.16-.41-.54-.25-.84.16-.3.54-.41.84-.25l2.83,1.55v-50.41l-85.94,15.02v57.25c0,.34-.27.62-.62.62h0Z",
    fill: "#224d6f"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M292.29,106.2v29.19l21.97-5.24v-27.99l-21.97,4.03Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.29,136.01c-.14,0-.27-.05-.38-.13-.15-.12-.23-.3-.23-.48v-29.19c0-.3.21-.55.5-.61l21.97-4.03c.18-.03.37.01.5.13.14.12.22.29.22.47v27.99c0,.29-.2.53-.47.6l-21.97,5.24s-.1.02-.14.02h0ZM292.91,106.71v27.9l20.74-4.95v-26.76l-20.74,3.81Z",
    fill: "#224d6f"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M314.27,130.77c-.08,0-.16-.01-.24-.05l-3.85-1.64c-.23-.1-.38-.32-.38-.57v-25.65c0-.34.27-.62.62-.62s.62.27.62.62v25.24l3.48,1.48c.31.13.46.5.33.81-.1.23-.33.38-.57.38h0Z",
    fill: "#224d6f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M292.29,133.07c-.28,0-.54-.2-.6-.48-.07-.33.14-.66.47-.73l18.12-3.94c.33-.07.66.14.73.47.07.33-.14.66-.47.73l-18.12,3.94s-.09.01-.13.01h0Z",
    fill: "#224d6f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M354.28,93.79v27.13l20.09-4.79v-26.66l-20.09,4.32Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M354.28,121.53c-.13,0-.27-.05-.38-.13-.15-.12-.23-.3-.23-.48v-27.13c0-.29.2-.54.49-.6l20.09-4.32c.18-.04.37,0,.52.12.15.12.23.29.23.48v26.66c0,.29-.2.53-.47.6l-20.09,4.79s-.1.02-.14.02h0ZM354.89,94.28v25.84l18.85-4.5v-25.41l-18.85,4.06h0Z",
    fill: "#224d6f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M374.36,116.39c-.09,0-.17-.02-.26-.06l-3.3-1.51c-.22-.1-.36-.32-.36-.56v-24.1c0-.34.27-.62.62-.62s.62.27.62.62v23.7l2.94,1.34c.31.14.45.51.3.82-.1.23-.33.36-.56.36h0Z",
    fill: "#224d6f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M354.28,118.3c-.29,0-.54-.2-.6-.49-.07-.33.15-.66.48-.73l16.79-3.42c.33-.07.66.15.73.48.07.33-.15.66-.48.73l-16.79,3.42s-.08.01-.12.01Z",
    fill: "#224d6f"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.28,93.79l.06,23.2,16.44-3.44.22-23.11-16.72,3.35Z",
    fill: "#224d6f"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.99,90.44v23.73l3.37,1.62v-26.32l-3.37.97Z",
    fill: "#224d6f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePlaceholder);
export default __webpack_public_path__ + "static/media/house_placeholder.22b44c1fe86acc19daa3f2dd10711d5d.svg";
export { ForwardRef as ReactComponent };